import React from 'react';
import { Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Chip } from '@mui/material';
import { cortes, formatearMoneda, formatearFecha } from '../data';

function CashRegister() {
  return (
    <Box>
      <Typography variant="h4" fontWeight={700} mb={3}>Cortes de Caja</Typography>

      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Turno</TableCell>
              <TableCell>Usuario</TableCell>
              <TableCell>Apertura</TableCell>
              <TableCell>Cierre</TableCell>
              <TableCell align="right">Monto Inicial</TableCell>
              <TableCell align="right">Efectivo</TableCell>
              <TableCell align="right">Tarjeta</TableCell>
              <TableCell align="right">Transferencia</TableCell>
              <TableCell align="right">Diferencia</TableCell>
              <TableCell align="center">Estado</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {cortes.map(c => (
              <TableRow key={c._id} hover>
                <TableCell fontWeight={600}>{c.turno}</TableCell>
                <TableCell>{c.usuario}</TableCell>
                <TableCell>{formatearFecha(c.fecha_apertura)}</TableCell>
                <TableCell>{formatearFecha(c.fecha_cierre)}</TableCell>
                <TableCell align="right">{formatearMoneda(c.monto_inicial)}</TableCell>
                <TableCell align="right">{formatearMoneda(c.monto_final_efectivo)}</TableCell>
                <TableCell align="right">{formatearMoneda(c.monto_final_tarjeta)}</TableCell>
                <TableCell align="right">{formatearMoneda(c.monto_final_transferencia)}</TableCell>
                <TableCell align="right">
                  <Chip label={formatearMoneda(c.diferencia)} size="small" color={c.diferencia === 0 ? 'success' : 'error'} variant="outlined" />
                </TableCell>
                <TableCell align="center">
                  <Chip label={c.estado === 'abierto' ? 'Abierto' : 'Cerrado'} size="small" color={c.estado === 'abierto' ? 'success' : 'default'} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default CashRegister;
